
import { defineComponent } from "vue";
import api, {
    RequestParams,
    SheqsyCompany,
    SheqsyCompanyDepartment,
    ReceiverExport,
} from "../../api/backend-api";
import { getHumanDate, getHumanDateDiff } from "../../util/luxonDateHelpers";
import { AxiosError } from "axios";

interface State {
    msg: string;
    company: SheqsyCompany;
    departments: SheqsyCompanyDepartment[];
    exportable: boolean;
    errors: AxiosError[];
}

export default defineComponent({
    name: "SheqsyCompanyForm",
    components: {},
    mounted() {
        this.$nextTick(() => {
            this.callGetCompany();
        });
    },
    data: (): State => {
        let company = {} as SheqsyCompany;
        let departments = [] as SheqsyCompanyDepartment[];
        return {
            msg: "Sheqsy Company Details",
            company: company,
            departments: departments,
            errors: [],
            exportable: false,
        };
    },
    methods: {
        getHumanDate,
        getHumanDateDiff,
        checkExportable(company: SheqsyCompany) {
            this.exportable = (company.SimsClass && company.Name && company.Departments ? true : false)
        },
        triggerExport(type: string) {
            const rxexport = {
                Name: this.company.Name + ' - ' + type + ' (sims)',
                Destination: 'sims',
                Type: type,
                SheqsyCompanyUId: this.company.CompanyUId
            } as ReceiverExport
            api.createReceiverExport(rxexport).then((response) => {
                this.$router.push({ name: "Receiver Export", params: { slug: response.data.id } })
            })
        },
        updateCompanyData() {
            const company = {
                Name: this.company.Name,
                CompanyUId: this.company.CompanyUId,
                ReceiverCode: this.company.ReceiverCode,
                SimsClass: this.company.SimsClass,
            } as SheqsyCompany
            api.saveSheqsyCompany(company).then((response) => {
                this.checkExportable(response.data)
                console.log("Saved company", response)
            })
                .catch((error: AxiosError) => {
                    console.error(error)
                })
        },
        callGetCompanyDepartments() {
            this.departments = []
            if (!this.company || !this.company.Departments) {
                return
            }
            const request_params = api.createRequestParams({ CompanyUId: this.company.CompanyUId }, { Skip: 0, Limit: 50, Options: [] }, { Pattern: "-DepartmentUId" })
            api.getSheqsyDepartmentList(request_params as RequestParams).then((response) => {
                this.departments = response.data.items ?? []
            })
                .catch((error: AxiosError) => {
                    this.departments = []
                    this.errors.push(error.response?.data.message)
                })
        },
        callGetCompany() {
            this.errors = [];
            let company_id = "";
            if (typeof this.$route.params.slug != "string") {
                throw new Error("Invalid url");
            }
            company_id = this.$route.params.slug;

            api
                .getSheqsyCompany(company_id)
                .then((response) => {
                    this.checkExportable(response.data)
                    this.company = response.data;
                    this.callGetCompanyDepartments()
                })
                .catch((error: AxiosError) => {
                    this.errors.push(error.response?.data.message);
                });
        },
    },
});
